import createIcon from '@/lib/create-icon'

const GiftIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none'>
    <path
      d='M3.33398 9.16602V12.4993C3.33398 15.2492 3.33398 16.6241 4.18826 17.4784C5.04253 18.3327 6.41746 18.3327 9.16732 18.3327H10.834C13.5838 18.3327 14.9587 18.3327 15.8131 17.4784C16.6673 16.6241 16.6673 15.2492 16.6673 12.4993V9.16602'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M2.5 7.50065C2.5 6.87758 2.5 6.56603 2.66747 6.33398C2.77717 6.18197 2.93497 6.05573 3.125 5.96796C3.41507 5.83398 3.80448 5.83398 4.58333 5.83398H15.4167C16.1955 5.83398 16.5849 5.83398 16.875 5.96796C17.065 6.05573 17.2228 6.18197 17.3325 6.33398C17.5 6.56603 17.5 6.87758 17.5 7.50065C17.5 8.12373 17.5 8.43523 17.3325 8.66732C17.2228 8.81932 17.065 8.94557 16.875 9.03332C16.5849 9.16732 16.1955 9.16732 15.4167 9.16732H4.58333C3.80448 9.16732 3.41507 9.16732 3.125 9.03332C2.93497 8.94557 2.77717 8.81932 2.66747 8.66732C2.5 8.43523 2.5 8.12373 2.5 7.50065Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M5 3.15411C5 2.33226 5.66624 1.66602 6.48809 1.66602H6.78572C8.56092 1.66602 10 3.1051 10 4.8803V5.83268H7.67857C6.19923 5.83268 5 4.63344 5 3.15411Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M15 3.15411C15 2.33226 14.3338 1.66602 13.5119 1.66602H13.2142C11.4391 1.66602 10 3.1051 10 4.8803V5.83268H12.3214C13.8007 5.83268 15 4.63344 15 3.15411Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M10 9.16602V18.3327'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
  </svg>,
  'GiftIcon'
)

export default GiftIcon
